import * as React from "react";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/material";
import DetailCardComp, {
  DetailInputDisplay,
} from "../../../Component/Common/ReuseableComponent/DetailCardComp";

export const PhysicalStockDetailTblCard = ({
  data = [],
  onClick = () => {},
  vMediaQuery,
}) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          width: "100%",
        }}
      >
        <Box
          sx={{
            height: vMediaQuery ? "65vh" : "75vh",
            overflowY: "auto",
            p: vMediaQuery ? "0px" : 1,
            width: "100%",
          }}
        >
          <Grid container spacing={1}>
            {Array.isArray(data) &&
              data.length > 0 &&
              data.map((item, index) => (
                <Grid
                  item
                  xs={12} // full width in mobile
                  sm={6} // 2 cards per row in tablet
                  md={6}
                  lg={4} // 3 cards per row in desktop
                  key={index}
                  sx={{
                    width: "100%",
                  }}
                >
                  <DetailCardComp
                    data={item}
                    onClick={() => onClick({ row: item })}
                    headerLabel={item.ItmName}
                    content={
                      <Grid
                        container
                        spacing={1}
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          // justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <DetailInputDisplay
                          label="Barcode"
                          value={item.B_Barcode}
                        />
                        {/* </Grid> */}

                        {/* QTY — small */}
                        <Grid
                          item
                          sx={{
                            flex: 1,
                            // width:'100%',
                            minWidth: vMediaQuery ? "0%" : "50px",
                            display: "flex",
                          }}
                        >
                          <DetailInputDisplay label="Qty" value={item.B_Qty} />
                        </Grid>

                        {/* UNIT — small */}
                        <Grid
                          item
                          sx={{
                            flex: 2,
                            minWidth: vMediaQuery ? "0%" : "100px",
                            display: "flex",
                          }}
                        >
                          <DetailInputDisplay
                            label="Unit"
                            value={item.B_Unit}
                          />
                        </Grid>
                      </Grid>
                    }
                  />
                </Grid>
              ))}
          </Grid>
        </Box>
      </Box>
    </>
  );
};
